import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';
import { ZalamoObject } from '../../../../../graphql';
import { first } from 'rxjs/operators';
import { LookBookOrderDetailsComponent } from '../../../../modules/look-book/components/look-book-order-details/look-book-order-details.component';
import { LookBookEditorService } from 'projects/photographer-panel/src/app/modules/look-book/look-book-editor.service';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';

@Component({
    selector: 'app-look-book-order-placed',
    templateUrl: './look-book-order-placed.component.html',
    styleUrls: ['./look-book-order-placed.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LookBookOrderPlacedComponent implements OnInit {
  ob: ZalamoObject = ZalamoObject.OrganizationClient;
  thumbs: Array<string>;

  private _details: UserWallEvent[UserWallEventType.LookBookOrderPlaced];

  get details(): UserWallEvent[UserWallEventType.LookBookOrderPlaced] {
    return this._details;
  }

  @Input()
  @ParseJson
  set details(value: UserWallEvent[UserWallEventType.LookBookOrderPlaced]) {
    this._details = value;
    this.thumbs = this._details.thumbs.slice(0, 3);
  }

  constructor(
    private lookBookEditorService: LookBookEditorService,
    private zalamoDialogService: ZalamoDialogService
  ) {}

  ngOnInit(): void {}

  showOrderDetails(index: number) {
    if (this.details.lookBookOrderId) {
      this.lookBookEditorService
        .getLookBookDetails(this.details.lookBookId)
        .pipe(first())
        .subscribe((lookBook) => {
          const ref = this.zalamoDialogService.openRight(
            LookBookOrderDetailsComponent
          );

          ref.componentInstance.lookBook = lookBook;
          ref.componentInstance.orderId = this.details.lookBookOrderId;
          ref.componentInstance.index = index;
        });
    }
  }
}
